export default function HeroSection() {
  const stats = [
    { label: '每日实时更新', desc: '片源不断' },
    { label: '全网资源覆盖', desc: '海量内容' },
    { label: '高清流畅播放', desc: '拒绝卡顿' },
  ];

  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span className="whitespace-nowrap">全网热门影视 · 实时追踪</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              白云视频
              <span className="block text-primary-500">手机免费高清视频播放平台</span>
            </h1>

            <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed">
              苹果视频 · 榴莲视频同款体验，海量资源一触即达
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              白云视频汇聚全网热门影视、综艺、动漫与短剧资源，每日实时更新，覆盖最新院线大片与经典佳作。无需注册即可在线观看，适配主流手机与平板设备，高清画质流畅不缓冲，为您打造掌上专属影院。当前热播剧集与话题持续追踪，不错过每一个精彩瞬间。
            </p>

            <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-foreground-900">{s.label}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{s.desc}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                立即体验
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[520px] md:w-[320px] md:h-[580px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20video%20streaming%20app%20interface%20with%20movie%20and%20drama%20thumbnails%20on%20a%20clean%20warm%20background%2C%20sleek%20UI%20design%20with%20poster%20grid%20layout%2C%20cinematic%20aesthetic%20with%20coral%20and%20amber%20accent%20colors%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%20style%2C%20dark%20phone%20frame%20contrast%20with%20bright%20colorful%20screen%20displaying%20Chinese%20entertainment%20content%2C%20high%20quality%20render%20with%20clean%20shadows&width=640&height=1160&seq=hero-phone-mockup&orientation=portrait"
                alt="白云视频手机App界面展示"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}